webpackJsonp([11557164830295],{

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(205);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLock = function FaLock(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.1 17.1h11.5v-4.2q0-2.4-1.7-4.1t-4-1.7-4.1 1.7-1.7 4.1v4.2z m18.6 2.2v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h0.8v-4.2q0-4.1 2.9-7.1t7.1-2.9 7 2.9 3 7.1v4.2h0.7q0.9 0 1.5 0.7t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaLock;
	module.exports = exports['default'];

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(299);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	        if (hocOptions.sourceType) {
	          _this2.context.registerElement(hocOptions.sourceType, element);
	        }
	      });
	    };
	
	    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        if (_this3.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this3.props.elementRef(_this3._element);
	        }
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    elementRef: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    elementRef: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _temp;
	};
	
	exports.default = Element;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRegisterElement = function (type, element) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2._elements) {
	          fn(_this2._elements);
	          return;
	        }
	
	        var _props = _this2.props,
	            children = _props.children,
	            options = _objectWithoutProperties(_props, ['children']);
	
	        if (_this2.context.tag === 'sync') {
	          _this2._elements = _this2.context.stripe.elements(options);
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      }
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(299);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        if (_this2.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this2.props.elementRef(_this2._element);
	        }
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.paymentRequest !== nextProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(nextProps);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  elementRef: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  elementRef: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && nextProps.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(nextProps.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(144);
	
	var _Provider = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.findElement = function (specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
	          var type = _ref.type;
	          return type === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (specifiedType) {
	        var element = _this.findElement(specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
	            var type = typeOrOptions.type,
	                rest = _objectWithoutProperties(typeOrOptions, ['type']);
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.requireElement(specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof typeOrOptions === 'string') {
	            return stripe.createToken(typeOrOptions, options);
	          } else {
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            var type = options.type,
	                rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars
	
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.findElement(specifiedType);
	            if (element) {
	              return stripe.createSource(element, rest);
	            } else if (specifiedType !== 'auto') {
	              return stripe.createSource(options);
	            } else {
	              throw new Error('You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.');
	            }
	          } else {
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe)
	      });
	    };
	    // Finds the element by the specified type. Throws if multiple Elements match.
	
	    // Require that exactly one Element is found.
	
	
	    // createToken has a bit of an unusual method signature for legacy reasons
	    // -- we're allowed to pass in the token type OR the element as the first parameter,
	    // so we need to check if we're passing in a string as the first parameter and
	    // just pass through the options if that's the case.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(209);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(597);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(144);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(595);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(596);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	var PostalCodeElement = (0, _Element2.default)('postalCode');
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PostalCodeElement = PostalCodeElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  margin: 0;\n  padding: 30px 0;\n\n  li {\n    list-style: none;\n    margin-bottom: 30px;\n    text-align: center;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  background: #fff;\n  margin: 0;\n  padding: 30px 0;\n\n  li {\n    list-style: none;\n    margin-bottom: 30px;\n    text-align: center;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  border-radius: 10px;\n  border: 1px solid #eaeaea;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);\n  overflow: hidden;\n"], ["\n  border-radius: 10px;\n  border: 1px solid #eaeaea;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);\n  overflow: hidden;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: #fff;\n  font-weight: 300;\n  text-align: center;\n"], ["\n  background: ", ";\n  color: #fff;\n  font-weight: 300;\n  text-align: center;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom: 1px solid #eee;\n  color: ", ";\n  text-align: center;\n"], ["\n  background: ", ";\n  border-bottom: 1px solid #eee;\n  color: ", ";\n  text-align: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  position: relative;\n"], ["\n  font-weight: 600;\n  position: relative;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  bottom: 2px;\n  color: #a9a9a9;\n  font-size: 11px;\n  font-weight: 300;\n  padding-left: 4px;\n  position: absolute;\n"], ["\n  bottom: 2px;\n  color: #a9a9a9;\n  font-size: 11px;\n  font-weight: 300;\n  padding-left: 4px;\n  position: absolute;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n"], ["\n  font-weight: 300;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  border-top: 1px dashed #eee;\n  text-align: center;\n"], ["\n  background: #fff;\n  border-top: 1px dashed #eee;\n  text-align: center;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  font-size: 16px;\n  height: 46px;\n  line-height: 46px;\n"], ["\n  background-color: ", ";\n  font-size: 16px;\n  height: 46px;\n  line-height: 46px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propsToOmit = ["title", "price", "currency", "period", "subscriberCount", "pricePerMessage", "subscribeButtonClick", "siteMetadata", "subscribeButtonLabel"];
	
	var PlanCard = function PlanCard(props) {
	  return _react2.default.createElement(
	    _rebass.Flex,
	    { wrap: true },
	    _react2.default.createElement(
	      CardBox,
	      (0, _lodash2.default)(props, propsToOmit),
	      _react2.default.createElement(
	        Title,
	        { p: [3], f: [2, 2, 4] },
	        props.title
	      ),
	      _react2.default.createElement(
	        PriceDetails,
	        { py: [3] },
	        _react2.default.createElement(
	          Price,
	          null,
	          "$",
	          props.price,
	          " ",
	          _react2.default.createElement(
	            Currency,
	            null,
	            props.currency
	          )
	        ),
	        _react2.default.createElement(
	          Period,
	          { f: [1] },
	          props.period
	        )
	      ),
	      _react2.default.createElement(
	        FeatureList,
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2] },
	            _react2.default.createElement(
	              "strong",
	              null,
	              props.subscriberCount,
	              " Qualified Leads"
	            ),
	            "*"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2] },
	            "Conversion Funnel Tracking"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2] },
	            "Live Chat Integration"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2] },
	            "Analytics Dashboard"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2] },
	            "Integration Tools"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Footer,
	        { py: ["20px"] },
	        _react2.default.createElement(
	          SubscribeButton,
	          {
	            is: "a",
	            href: props.siteMetadata.appUrl,
	            onClick: props.subscribeButtonClick
	          },
	          props.subscribeButtonLabel
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      { mt: [4] },
	      _react2.default.createElement(
	        _rebass.Text,
	        { f: [1], color: "gray3", align: "center" },
	        _react2.default.createElement(
	          "em",
	          null,
	          "* Qualified Leads = Non-converted or disqualified lead + Any qualified leads in current month"
	        )
	      )
	    )
	  );
	};
	
	exports.default = PlanCard;
	
	
	PlanCard.defaultProps = {
	  subscribeButtonLabel: "Get Started"
	};
	
	// Styled Components
	var FeatureList = _styledComponents2.default.ul(_templateObject);
	
	var CardBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var Title = (0, _styledComponents2.default)(_rebass.Heading)(_templateObject3, function (p) {
	  return p.theme.colors.support2;
	});
	
	var PriceDetails = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4, function (p) {
	  return p.theme.colors.beige;
	}, function (p) {
	  return p.theme.colors.support2;
	});
	
	var Price = (0, _styledComponents2.default)(_rebass.Text)(_templateObject5);
	
	var Currency = _styledComponents2.default.span(_templateObject6);
	
	var Period = (0, _styledComponents2.default)(_rebass.Text)(_templateObject7);
	
	var Footer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject8);
	
	var SubscribeButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject9, function (p) {
	  return p.theme.colors.facebookBlue;
	});
	module.exports = exports["default"];

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(145);
	
	var _rebass = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardSection = function CardSection(_ref) {
	  var disabled = _ref.disabled;
	  return _react2.default.createElement(
	    "label",
	    { htmlFor: "cardInput" },
	    _react2.default.createElement(
	      _rebass.Text,
	      { f: [2], color: "support2" },
	      "Credit or debit card"
	    ),
	    _react2.default.createElement(_reactStripeElements.CardElement, {
	      name: "cardInput",
	      style: { base: { fontSize: "16px" } },
	      disabled: disabled
	    })
	  );
	}; // CardSection.js
	exports.default = CardSection;
	module.exports = exports["default"];

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: 5px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  left: 0;\n  margin: 0 auto;\n  max-width: 500px;\n  overflow: hidden;\n  padding: 20px;\n  position: relative;\n  width: 100%;\n  z-index: 3;\n\n  .StripeElement {\n    -webkit-transition: box-shadow 150ms ease;\n    background-color: white;\n    height: 50px;\n    padding: 15px 12px;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    margin: 15px 0 20px;\n    transition: box-shadow 150ms ease;\n  }\n\n  .StripeElement--focus {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n  }\n\n  .StripeElement--invalid {\n    border-color: ", ";\n  }\n\n  .StripeElement--webkit-autofill {\n    background-color: #fefde5 !important;\n  }\n"], ["\n  background: ", ";\n  border-radius: 5px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  left: 0;\n  margin: 0 auto;\n  max-width: 500px;\n  overflow: hidden;\n  padding: 20px;\n  position: relative;\n  width: 100%;\n  z-index: 3;\n\n  .StripeElement {\n    -webkit-transition: box-shadow 150ms ease;\n    background-color: white;\n    height: 50px;\n    padding: 15px 12px;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    box-shadow: 0 1px 3px 0 #e6ebf1;\n    margin: 15px 0 20px;\n    transition: box-shadow 150ms ease;\n  }\n\n  .StripeElement--focus {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n  }\n\n  .StripeElement--invalid {\n    border-color: ", ";\n  }\n\n  .StripeElement--webkit-autofill {\n    background-color: #fefde5 !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-top: 0;\n"], ["\n  padding-top: 0;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  -webkit-transition: box-shadow 150ms ease;\n  background-color: white;\n  height: 50px;\n  padding: 15px 12px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 3px 0 #e6ebf1;\n  margin: 15px 0 20px;\n  transition: box-shadow 150ms ease;\n  width: 100%;\n\n  &:focus {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n    outline: none;\n  }\n\n  &.invalid {\n    border-color: ", ";\n\n    &::placeholder {\n      color: #e2857d;\n    }\n  }\n"], ["\n  -webkit-transition: box-shadow 150ms ease;\n  background-color: white;\n  height: 50px;\n  padding: 15px 12px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 3px 0 #e6ebf1;\n  margin: 15px 0 20px;\n  transition: box-shadow 150ms ease;\n  width: 100%;\n\n  &:focus {\n    box-shadow: 0 1px 3px 0 #cfd7df;\n    outline: none;\n  }\n\n  &.invalid {\n    border-color: ", ";\n\n    &::placeholder {\n      color: #e2857d;\n    }\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: 5px;\n  color: #fff;\n  margin: 0 0 15px 0;\n  padding: 16px;\n"], ["\n  background: ", ";\n  border-radius: 5px;\n  color: #fff;\n  margin: 0 0 15px 0;\n  padding: 16px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-top: 6px;\n"], ["\n  margin-top: 6px;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: rgba(38, 213, 115, 0.7);\n  margin-top: -3px;\n  position: absolute;\n  right: 20px;\n"], ["\n  color: rgba(38, 213, 115, 0.7);\n  margin-top: -3px;\n  position: absolute;\n  right: 20px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactStripeElements = __webpack_require__(145);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _lock = __webpack_require__(591);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _CardSection = __webpack_require__(322);
	
	var _CardSection2 = _interopRequireDefault(_CardSection);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _powered_by_stripe2x = __webpack_require__(642);
	
	var _powered_by_stripe2x2 = _interopRequireDefault(_powered_by_stripe2x);
	
	var _stripe_secure_small = __webpack_require__(643);
	
	var _stripe_secure_small2 = _interopRequireDefault(_stripe_secure_small);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fragment = _react2.default.Fragment;
	
	var CheckoutForm = function (_React$Component) {
	  _inherits(CheckoutForm, _React$Component);
	
	  function CheckoutForm(props) {
	    _classCallCheck(this, CheckoutForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.setError = function (item, error) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[item] = error, _this$setState));
	    };
	
	    _this.setSubmitting = function (submitting) {
	      _this.setState({
	        submitting: submitting
	      });
	    };
	
	    _this.close = function () {
	      window.location.href = "https://www.messenger.com/closeWindow/";
	
	      _this.context.mixpanel.track("demo_subscribe_closed");
	    };
	
	    _this.handleStripeSuccess = function (token) {
	      _this.setState({
	        // stripeToken: token,
	        showPostCheckout: true
	      });
	    };
	
	    _this.handleSubmit = function (ev) {
	      // We don't want to let default form submission happen here, which would refresh the page.
	      ev.preventDefault();
	
	      if (!_this.state.customerName) {
	        _this.setError("customerNameError", "Please enter a name...");
	        return false;
	      }
	
	      _this.context.mixpanel.track("demo_subscribe_checkout_click", {
	        name: _this.state.customerName
	      });
	
	      _this.setSubmitting(true);
	
	      // Within the context of `Elements`, this call to createToken knows which Element to
	      // tokenize, since there's only one in this group.
	      return _this.props.stripe.createToken({ name: _this.state.customerName }).then(function (_ref) {
	        var token = _ref.token,
	            error = _ref.error;
	
	        if (error) throw new Error(error.message);
	
	        _this.handleStripeSuccess(token);
	        _this.setSubmitting(false);
	      }).catch(function (error) {
	        _this.setError("cardError", error.message);
	        _this.setSubmitting(false);
	      });
	    };
	
	    _this.updateCustomerName = function (e) {
	      _this.setState({
	        customerName: e.target.value
	      });
	    };
	
	    _this.checkoutRender = function () {
	      var _this$state = _this.state,
	          customerName = _this$state.customerName,
	          submitting = _this$state.submitting,
	          customerNameError = _this$state.customerNameError,
	          cardError = _this$state.cardError,
	          serverError = _this$state.serverError;
	
	
	      return _react2.default.createElement(
	        Fragment,
	        null,
	        (cardError || serverError) && _react2.default.createElement(
	          ErrorText,
	          null,
	          _react2.default.createElement(
	            "span",
	            {
	              role: "img",
	              className: "middle",
	              "aria-label": "Shocked little emoji dude"
	            },
	            "\uD83D\uDE2E"
	          ),
	          cardError || serverError,
	          " "
	        ),
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "customerName" },
	          _react2.default.createElement(
	            StyledLock,
	            null,
	            _react2.default.createElement(_lock2.default, { size: 22 })
	          ),
	          _react2.default.createElement(
	            _rebass.Text,
	            { f: [2], color: "support2" },
	            "Cardholder name"
	          ),
	          _react2.default.createElement(NameInput, {
	            name: "customerName",
	            value: customerName,
	            onChange: _this.updateCustomerName,
	            placeholder: customerNameError,
	            className: customerNameError ? "invalid" : "",
	            disabled: submitting
	          })
	        ),
	        _react2.default.createElement(_CardSection2.default, { disabled: submitting }),
	        _react2.default.createElement(
	          _rebass.Flex,
	          { align: "center" },
	          _react2.default.createElement(
	            _rebass.Box,
	            null,
	            _react2.default.createElement(StyledImg, {
	              src: _powered_by_stripe2x2.default,
	              alt: "Powered by Stripe",
	              width: "108px",
	              className: "middle"
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            { ml: "auto" },
	            _react2.default.createElement(
	              CheckoutButton,
	              {
	                type: "submit",
	                disabled: submitting,
	                loading: submitting ? "loading" : ""
	              },
	              submitting ? "Subscribing" : "Subscribe"
	            )
	          )
	        )
	      );
	    };
	
	    _this.postCheckoutRender = function () {
	      return _react2.default.createElement(
	        Fragment,
	        null,
	        _react2.default.createElement(
	          _rebass.Heading,
	          { mb: [3], f: [3], color: "error" },
	          "Payment declined by Pipeline"
	        ),
	        _react2.default.createElement(
	          _rebass.Text,
	          { mb: [3], f: [2] },
	          "We are still in beta and only accepting payments from existing customers who qualify for the program. If you're interested in joining, you can do so by sending us a message via Messenger."
	        ),
	        _react2.default.createElement(
	          _rebass.Text,
	          { mb: [3], f: [2] },
	          "We have not charged your card."
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { mb: [2, 2, 3, 4], onClick: _this.close },
	          "Close Demo"
	        )
	      );
	    };
	
	    _this.state = {
	      customerName: "",
	      showPostCheckout: false,
	      submitting: false,
	      stripeToken: {}
	    };
	    return _this;
	  }
	
	  // async createCustomer(token) {
	  //   try {
	  //     const result = await request(`${API}/account/payment`, "post", {
	  //       tokenId: token.id,
	  //       facebookPageId: this.store.app.facebookPageId
	  //     });
	
	  //     if (has(result, "id")) {
	  //       this.store.app.getAccountDetails();
	
	  //       if (typeof this.props.onClose === "function") this.props.onClose();
	  //       if (typeof this.props.onSuccess === "function") this.props.onSuccess();
	  //     } else if (has(result, "message")) {
	  //       throw new Error(result.message);
	  //     } else {
	  //       throw new Error("No response from the server");
	  //     }
	
	  //     this.setSubmitting(false);
	  //   } catch (error) {
	  //     handleErrorResponse(error).then(() => {
	  //       const response = `Sorry but we couldn't take your payment! Our team has been notified and we're looking into what happened.${
	  //         !isProduction ? ` Server response: ${error}` : ""
	  //       }`;
	  //       this.setError("serverError", response);
	  //     });
	
	  //     this.setSubmitting(false);
	  //   }
	  // }
	
	  CheckoutForm.prototype.render = function render() {
	    var showPostCheckout = this.state.showPostCheckout;
	
	
	    return _react2.default.createElement(
	      Fragment,
	      null,
	      _react2.default.createElement(
	        _rebass.Text,
	        { align: "center", mb: [3], color: "support2", f: "14px" },
	        _react2.default.createElement(_reactImage2.default, {
	          src: _stripe_secure_small2.default,
	          alt: "Secure Payments powered by Stripe",
	          width: "200"
	        })
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        { align: "center", mb: [2], color: "support1", f: "15px" },
	        "Cancel Any time - No lock in contract"
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        { align: "center", mb: [4], color: "support1", f: "15px" },
	        "Site encrypted with 128-bit SSL encryption"
	      ),
	      _react2.default.createElement(
	        StyledForm,
	        { onSubmit: this.handleSubmit },
	        !showPostCheckout ? this.checkoutRender() : this.postCheckoutRender()
	      )
	    );
	  };
	
	  return CheckoutForm;
	}(_react2.default.Component);
	
	CheckoutForm.contextTypes = { mixpanel: _propTypes2.default.object.isRequired };
	
	exports.default = (0, _reactStripeElements.injectStripe)(CheckoutForm);
	
	// Styled Components
	
	var StyledForm = _styledComponents2.default.form(_templateObject, function (p) {
	  return p.theme.colors.gray1;
	}, function (p) {
	  return p.theme.colors.error;
	});
	
	var CheckoutButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2);
	
	var NameInput = _styledComponents2.default.input(_templateObject3, function (p) {
	  return p.theme.colors.error;
	});
	
	var ErrorText = (0, _styledComponents2.default)(_rebass.Text)(_templateObject4, function (p) {
	  return p.theme.colors.error;
	});
	
	var StyledImg = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject5);
	
	var StyledLock = _styledComponents2.default.div(_templateObject6);
	module.exports = exports["default"];

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: 5px;\n  color: #fff;\n\n  a {\n    color: #fff;\n  }\n"], ["\n  background: ", ";\n  border-radius: 5px;\n  color: #fff;\n\n  a {\n    color: #fff;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(145);
	
	var _reactLoadScript = __webpack_require__(122);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _config = __webpack_require__(125);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ErrorBanner from "../ui/Banner/ErrorBanner";
	
	var Fragment = _react2.default.Fragment;
	
	var Stripe = function (_Component) {
	  _inherits(Stripe, _Component);
	
	  function Stripe(props) {
	    _classCallCheck(this, Stripe);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleScriptCreate = function () {
	      _this.setState({
	        stripeLoaded: false
	      });
	    };
	
	    _this.handleScriptError = function () {
	      _this.setState({
	        stripeError: true
	      });
	    };
	
	    _this.handleScriptLoad = function () {
	      _this.setState({
	        stripeLoaded: true
	      });
	    };
	
	    _this.rerender = function () {
	      _this.setState({
	        stripeLoaded: false,
	        stripeError: false
	      });
	
	      window.location.reload();
	    };
	
	    _this.state = {
	      stripeLoaded: false
	    };
	    return _this;
	  }
	
	  Stripe.prototype.render = function render() {
	    var _state = this.state,
	        stripeLoaded = _state.stripeLoaded,
	        stripeError = _state.stripeError;
	
	
	    return _react2.default.createElement(
	      Fragment,
	      null,
	      _react2.default.createElement(_reactLoadScript2.default, {
	        url: "https://js.stripe.com/v3/",
	        onCreate: this.handleScriptCreate,
	        onError: this.handleScriptError,
	        onLoad: this.handleScriptLoad
	      }),
	      stripeError && _react2.default.createElement(
	        ErrorText,
	        { m: [2, 2, "16px"], mb: [3], p: [3], f: [1] },
	        "It looks like there's been an error, hence the big red box. Please ",
	        _react2.default.createElement(
	          "button",
	          { onClick: this.rerender },
	          "click here"
	        ),
	        " to reload."
	      ),
	      !stripeLoaded && !stripeError && _react2.default.createElement(
	        StyledText,
	        { py: ["50px"], f: [2], className: "loading" },
	        "Loading"
	      ),
	      stripeLoaded && !stripeError && _react2.default.createElement(
	        _reactStripeElements.StripeProvider,
	        { apiKey: _config2.default.stripe.key },
	        this.props.render
	      )
	    );
	  };
	
	  return Stripe;
	}(_react.Component);
	
	exports.default = Stripe;
	
	// Styled Components
	
	var StyledText = (0, _styledComponents2.default)(_rebass.Text)(_templateObject);
	
	var ErrorText = (0, _styledComponents2.default)(_rebass.Text)(_templateObject2, function (p) {
	  return p.theme.colors.error;
	});
	module.exports = exports["default"];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(145);
	
	var _CheckoutForm = __webpack_require__(323);
	
	var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StripeCheckout = function StripeCheckout(_ref) {
	  var onClose = _ref.onClose,
	      onSuccess = _ref.onSuccess;
	  return _react2.default.createElement(
	    _reactStripeElements.Elements,
	    null,
	    _react2.default.createElement(_CheckoutForm2.default, { onClose: onClose, onSuccess: onSuccess })
	  );
	};
	
	exports.default = StripeCheckout;
	module.exports = exports["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stripe_secure_small.eedbb42e.jpg";

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.subscribePageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: 54px;\n  line-height: 54px;\n  text-align: center;\n"], ["\n  height: 54px;\n  line-height: 54px;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);\n  height: 56px;\n  padding-top: 15px;\n  position: relative;\n  width: auto;\n  z-index: 1;\n"], ["\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);\n  height: 56px;\n  padding-top: 15px;\n  position: relative;\n  width: auto;\n  z-index: 1;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  max-width: 380px;\n  width: 100%;\n"], ["\n  max-width: 380px;\n  width: 100%;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _logo = __webpack_require__(213);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Stripe = __webpack_require__(324);
	
	var _Stripe2 = _interopRequireDefault(_Stripe);
	
	var _StripeCheckout = __webpack_require__(325);
	
	var _StripeCheckout2 = _interopRequireDefault(_StripeCheckout);
	
	var _FacebookButton = __webpack_require__(31);
	
	var _FacebookButton2 = _interopRequireDefault(_FacebookButton);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PlanCard = __webpack_require__(152);
	
	var _PlanCard2 = _interopRequireDefault(_PlanCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fragment = _react2.default.Fragment;
	
	var PageTemplate = function (_Component) {
	  _inherits(PageTemplate, _Component);
	
	  function PageTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      loggedIn: false,
	      step: 0
	    }, _this.handleLogin = function () {
	      _this.setState({
	        loggedIn: true,
	        step: 1
	      });
	
	      _this.context.mixpanel.track("demo_subscribe_logged_in");
	    }, _this.changeStep = function () {
	      var step = _this.state.step;
	
	      _this.setState({
	        step: step + 1
	      });
	
	      _this.context.mixpanel.track("demo_subscribe_step", { step: step + 1 });
	    }, _this.close = function () {
	      _this.context.mixpanel.track("demo_subscribe_closed");
	
	      window.location.href = "https://www.messenger.com/closeWindow/";
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PageTemplate.prototype.componentDidMount = function componentDidMount() {
	    this.context.mixpanel.track("demo_subscribe_step", { step: 0 });
	  };
	
	  PageTemplate.prototype.render = function render() {
	    var siteMetadata = this.props.siteMetadata;
	    var _state = this.state,
	        loggedIn = _state.loggedIn,
	        step = _state.step;
	
	
	    return _react2.default.createElement(
	      Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { htmlAttributes: { class: "internal-page" } }),
	      _react2.default.createElement(
	        LogoBox,
	        { mt: [4], mb: [3] },
	        _react2.default.createElement("img", { src: _logo2.default, alt: "Pipeline", height: "27" })
	      ),
	      _react2.default.createElement(
	        _rebass.Container,
	        { mb: [5] },
	        !loggedIn && _react2.default.createElement(Auth, { handleLogin: this.handleLogin }),
	        loggedIn && step === 1 && _react2.default.createElement(Package, {
	          siteMetadata: siteMetadata,
	          changeStep: this.changeStep
	        }),
	        loggedIn && step === 2 && _react2.default.createElement(_Stripe2.default, {
	          render: _react2.default.createElement(
	            Fragment,
	            null,
	            _react2.default.createElement(_StripeCheckout2.default, null)
	          )
	        })
	      )
	    );
	  };
	
	  return PageTemplate;
	}(_react.Component);
	
	PageTemplate.contextTypes = { mixpanel: _propTypes2.default.object.isRequired };
	
	var Auth = function Auth(_ref) {
	  var handleLogin = _ref.handleLogin;
	  return _react2.default.createElement(
	    Fragment,
	    null,
	    _react2.default.createElement(
	      _rebass.Text,
	      { align: "center", mb: [4] },
	      "Let's get started by setting up your account\u2026"
	    ),
	    _react2.default.createElement(
	      _rebass.Text,
	      { align: "center" },
	      _react2.default.createElement(
	        StyledFacebookButton,
	        { mb: [2, 2, 3, 4], onClick: handleLogin },
	        "LOGIN WITH FACEBOOK"
	      )
	    )
	  );
	};
	
	var Package = function Package(_ref2) {
	  var siteMetadata = _ref2.siteMetadata,
	      changeStep = _ref2.changeStep;
	  return _react2.default.createElement(
	    PlanFlex,
	    { wrap: true, mx: "auto" },
	    _react2.default.createElement(_PlanCard2.default, {
	      w: [1, 1, "auto"],
	      my: [2],
	      flex: ["auto"],
	      title: "Starter Package",
	      price: "49.00",
	      currency: "usd",
	      period: "per month",
	      subscriberCount: 250,
	      subscribeButtonClick: changeStep,
	      siteMetadata: siteMetadata,
	      subscribeButtonLabel: "Proceed to Payment"
	    })
	  );
	};
	
	exports.default = function (_ref3) {
	  var data = _ref3.data;
	  var siteMetadata = data.site.siteMetadata;
	
	
	  return _react2.default.createElement(PageTemplate, { siteMetadata: siteMetadata });
	};
	
	var subscribePageQuery = exports.subscribePageQuery = "** extracted graphql fragment **";
	
	// Styled Components
	var LogoBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var StyledFacebookButton = (0, _styledComponents2.default)(_FacebookButton2.default)(_templateObject2);
	
	var PlanFlex = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject3);

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var isProduction = exports.isProduction = ("production") === "production";
	
	var config = {
	  gtm: {
	    id: "GTM-P257L7B"
	  },
	  stripe: {
	    key: isProduction ? "pk_live_mIIVRaa2HwgFIv3JgIf8XRHp" : "pk_test_s2UCJ5ulUf8PLG2ggfGFZ3Ty"
	  },
	  mixpanel: {
	    key: isProduction ? "0a9c9627a67d3492bbc34cc268ffd035" : "12003c166a134aa4dd01c4ae19029d43"
	  }
	};
	
	exports.default = config;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-subscribe-page-js-729090231d22f8ed2490.js